import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=c6860486&scoped=true&"
import script from "./HomeSection.vue?vue&type=script&lang=ts&"
export * from "./HomeSection.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSection.vue?vue&type=style&index=0&id=c6860486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6860486",
  null
  
)

export default component.exports